import { genericPage, getServerSidePropsHelper, getMappingEleccions3CatInfo, getSlugEleccio } from 'components/3catinfo/Page';
import __isEmpty from 'lodash/isEmpty';
import { useRouter } from 'next/router';

const Pagina = (props) => {
    const router = useRouter();
    return genericPage(props, router, ['web', process.env.FOLDER_LAYOUTS_3CATINFO, 'eleccions']);
};

export async function getServerSideProps(context) {
    const { slugEmbed } = context.query;
    const slugEleccio = getSlugEleccio(context?.resolvedUrl);
    const mapping = await getMappingEleccions3CatInfo(slugEleccio);
    if (__isEmpty(mapping)) {
        return {
            notFound: true
        };
    }
    const path = ['web', process.env.FOLDER_LAYOUTS_3CATINFO, 'eleccions', slugEleccio, 'embed', slugEmbed];
    return getServerSidePropsHelper(context, { slugs: path });
}

export default Pagina;
